/**
 * Mock data for fallback service
 * This provides realistic data for development when the server is unavailable
 */

// Mock users
export const mockUsers = [
  {
    id: 1,
    username: 'admin',
    name: 'Admin User',
    email: 'admin@example.com',
    role: 'admin'
  },
  {
    id: 2,
    username: 'operator',
    name: 'Operator User',
    email: 'operator@example.com',
    role: 'operator'
  },
  {
    id: 4,
    username: 'super',
    name: 'Super User',
    email: 'super@example.com',
    role: 'super_user'
  },
  {
    id: 3,
    username: 'user',
    name: 'End User',
    email: 'user@example.com',
    role: 'end_user'
  }
];

// Mock sites
export const mockSites = [
  {
    id: 1,
    name: 'Office Building',
    location: '123 Main St, City',
    description: 'Main office building with 5 floors',
    totalDevices: 12,
    activeDevices: 10,
    totalUsage: 45000,
    status: 'Active'
  },
  {
    id: 2,
    name: 'Warehouse',
    location: '456 Industrial Blvd, City',
    description: 'Main warehouse and distribution center',
    totalDevices: 8,
    activeDevices: 7,
    totalUsage: 32000,
    status: 'Active'
  },
  {
    id: 3,
    name: 'Retail Store',
    location: '789 Market St, City',
    description: 'Flagship retail location',
    totalDevices: 5,
    activeDevices: 5,
    totalUsage: 18000,
    status: 'Active'
  }
];

// Mock devices
export const mockDevices = [
  {
    id: 1,
    serialNumber: 'DEV-1-001',
    description: 'Water Meter 1',
    type: 'Water Meter',
    model: 'H2O-Pro 3000',
    manufacturer: 'AquaTech Industries',
    installDate: '2024-09-15T00:00:00.000Z',
    lastMaintenance: '2025-02-28T00:00:00.000Z',
    status: 'Active',
    location: 'Building A, Floor 1, Room 101',
    siteId: 1,
    siteName: 'Office Building'
  },
  {
    id: 2,
    serialNumber: 'DEV-1-002',
    description: 'Water Meter 2',
    type: 'Water Meter',
    model: 'H2O-Pro 3000',
    manufacturer: 'AquaTech Industries',
    installDate: '2024-09-15T00:00:00.000Z',
    lastMaintenance: '2025-02-28T00:00:00.000Z',
    status: 'Active',
    location: 'Building A, Floor 2, Room 201',
    siteId: 1,
    siteName: 'Office Building'
  },
  {
    id: 3,
    serialNumber: 'DEV-2-001',
    description: 'Water Meter 3',
    type: 'Water Meter',
    model: 'H2O-Pro 2500',
    manufacturer: 'AquaTech Industries',
    installDate: '2024-10-05T00:00:00.000Z',
    lastMaintenance: '2025-02-15T00:00:00.000Z',
    status: 'Maintenance',
    location: 'Warehouse, Section A',
    siteId: 2,
    siteName: 'Warehouse'
  }
];

// Mock readings
export const mockReadings = Array.from({ length: 100 }, (_, i) => {
  const deviceId = Math.floor(Math.random() * 3) + 1;
  const timestamp = new Date(Date.now() - (99 - i) * 3600 * 1000).toISOString();
  return {
    id: i + 1,
    deviceId,
    timestamp,
    value: Math.random() * 100 + 10, // 10-110 liters
    flowRate: Math.random() * 5 + 1, // 1-6 liters/min
    temperature: Math.random() * 10 + 15, // 15-25 degrees C
    pressure: Math.random() * 2 + 3 // 3-5 bar
  };
});

// Mock daily usage
export const mockDailyUsage = Array.from({ length: 30 }, (_, i) => {
  const date = new Date(Date.now() - (29 - i) * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  return {
    date,
    value: Math.random() * 1000 + 500 // 500-1500 liters
  };
});
